import {Chart} from './chart';
import {Constants as constants} from '../config/constants';
import {Rect} from '@/types/primitives';
import {ChartData} from '@/types/data';
import {Selection as D3Selection} from 'd3';

export class LegendRenderer {
    private availableTypes = [] as string[];
    private groupRect = null as unknown as Rect;
    private legendGroup = null as unknown as D3Selection<any, any, any, any>;

    constructor(private chart: Chart, private chartData: ChartData) {
        this.analyzeData();
    }

    public render() {
        this.calculateGroupRect();
        this.renderCategories();
        this.alignContainer();
    }

    private analyzeData() {
        for (const type in this.chartData) {
            if (this.chartData.hasOwnProperty(type)) {
                const typeToAdd = type.split('-').shift();

                if (!this.availableTypes.some((entry) => entry === typeToAdd)) {
                    this.availableTypes.push(typeToAdd!);
                }
            }
        }
    }

    private calculateGroupRect() {
        const groupSize = this.chart.node.group.node().getBBox();
        this.groupRect = {
            left: this.chart.toolList.pathRenderer.data.center.x - groupSize.width / 2,
            top: this.chart.toolList.pathRenderer.data.center.y - groupSize.height / 2,
            right: this.chart.toolList.pathRenderer.data.center.x + groupSize.width / 2,
            bottom: this.chart.toolList.pathRenderer.data.center.y + groupSize.height / 2
        };
    }

    private renderCategories() {
        this.legendGroup = this.chart.node.group
            .append('g');

        const position = {
            x: (this.groupRect.right + this.groupRect.left) / 2,
            y: this.groupRect.bottom
        };

        this.availableTypes.map((type) => {
            this.legendGroup
                .append('rect')
                .attr('x', position.x)
                .attr('y', position.y - constants.legendSquareSize)
                .attr('width', constants.legendSquareSize)
                .attr('height', constants.legendSquareSize)
                .attr('class', `shape-${type}`);

            position.x += constants.legendSquareSize + constants.legendPadding;

            const typeText = this.legendGroup
                .append('text')
                .text(type)
                .attr('x', position.x)
                .attr('y', position.y)
                .attr('class', 'label legend');

            position.x += (typeText.node() as SVGTextElement).getBBox().width + constants.legendPadding * 2;
        });
    }

    private alignContainer() {
        this.legendGroup
            .attr('transform', `translate(${-(this.legendGroup.node() as SVGGElement).getBBox().width / 2}, 0)`);
    }
}
